import React, {useState} from 'react'
import PropTypes from "prop-types";
import {GameBestOfLegsComponent, GameFirstToLegsComponent, GameToLegsComponent} from "../../general/GameFirstToLegsComponent";
import {GameModusComponent} from "../../general/GameModusComponent";
import {GameStartpunkteComponent} from "../../general/GameStartpunkteComponent";
import {GameSetsComponent} from "../../general/GameSetsComponent";
import DHButtonDefault from "../../general/DHButtonDefault";
import DHDefaultDrawer from "../../general/DHDefaultDrawer";
import {GameAusbullenComponent} from "../../general/GameAusbullenComponent";

function TournamentX01Area({showSets, showBestOfLegs, showToLegs, showPflichtfelder, sets, firstToLegs, bestOfLegs, toLegs, modusId, startpunkte, onSetsChanged, onFirstToLegsChanged, onBestOfLegsChanged, onToLegsChanged, onModusIdChanged, onStartpunkteChanged, aufnahmenBisBullen, onAufnahmenBisBullenChanged, bullenDisabled}) {

    const [showBullenNotice, setShowBullenNotice] = useState(false);

    // Beschriftung und Stift-Button auf einer Linie
    const rowStyle = {alignItems: "center"};

    return <>
        <div style={{marginBottom:20}}>
            <DHButtonDefault label="Standard setzen" onClick={() => {
                    if( showSets ) {
                        onSetsChanged(1);
                    }
                    if( showBestOfLegs ) {
                        onBestOfLegsChanged(5);
                        onFirstToLegsChanged(undefined);
                        if( onToLegsChanged  !== undefined) {
                            onToLegsChanged(undefined)
                        }
                    } else {
                        if( onBestOfLegsChanged !== undefined) {
                            onBestOfLegsChanged(undefined);
                        }
                        if( onToLegsChanged  !== undefined) {
                            onToLegsChanged(undefined)
                        }
                        onFirstToLegsChanged(3);
                    }
                    onStartpunkteChanged(501);
                    onModusIdChanged("double_out");
                    if( onAufnahmenBisBullenChanged !== undefined && !bullenDisabled) {
                        onAufnahmenBisBullenChanged(undefined);
                    }
                }}
                />
        </div>
        {showSets &&
            <div className="grid" style={rowStyle}>
                <div className="col-fixed" style={{width: "120px",  color: showPflichtfelder && (sets === undefined || sets === null || sets === "") ? "red" : ""}}>first to sets: {showPflichtfelder && "*" }</div>
                <div className="col">
                    <GameSetsComponent sets={sets}
                                       onChange={(sets) => onSetsChanged(sets)}/>
                </div>
            </div>
        }
        <div className="grid" style={rowStyle}>
            <div className="col-fixed" style={{width: "120px",  color: bestOfLegs === undefined && showPflichtfelder && (firstToLegs === undefined || firstToLegs === null || firstToLegs === "") ? "red" : ""}}>first to
                legs: {bestOfLegs === undefined && showPflichtfelder && "*"}</div>
            <div className="col">
                <GameFirstToLegsComponent firstToLegs={firstToLegs}
                                          onChange={(firstToLegs) => {
                                              onFirstToLegsChanged(firstToLegs);
                                              if( firstToLegs !== undefined && onBestOfLegsChanged !== undefined) {
                                                  onBestOfLegsChanged(undefined);
                                              }
                                              if( firstToLegs !== undefined && onToLegsChanged !== undefined) {
                                                  onToLegsChanged(undefined);
                                              }
                                          }}/>
            </div>
        </div>
        {showBestOfLegs &&
            <div className="grid" style={rowStyle}>
                <div className="col-fixed" style={{width: "120px",  color: firstToLegs === undefined && showPflichtfelder && (bestOfLegs === undefined || bestOfLegs === null || bestOfLegs === "") ? "red" : ""}}>best of
                    legs: {firstToLegs === undefined && showPflichtfelder && "*"}</div>
                <div className="col">
                    <GameBestOfLegsComponent bestOfLegs={bestOfLegs}
                                              onChange={(bestOfLegs) => {
                                                  onBestOfLegsChanged(bestOfLegs);
                                                  if( bestOfLegs !== undefined ) {
                                                      onFirstToLegsChanged(undefined);
                                                  }
                                                  if( bestOfLegs !== undefined && onToLegsChanged !== undefined) {
                                                      onToLegsChanged(undefined);
                                                  }

                                              }}/>
                </div>
            </div>
        }
        {showToLegs &&
            <div className="grid" style={rowStyle}>
                <div className="col-fixed" style={{width: "120px",  color: firstToLegs === undefined && showPflichtfelder && (toLegs === undefined || toLegs === null || toLegs === "") ? "red" : ""}}>
                    legs: {toLegs === undefined && showPflichtfelder && "*"}</div>
                <div className="col">
                    <GameToLegsComponent toLegs={toLegs}
                                             onChange={(toLegs) => {
                                                 onToLegsChanged(toLegs);
                                                 if( toLegs !== undefined) {
                                                     onFirstToLegsChanged(undefined);
                                                     onBestOfLegsChanged(undefined);
                                                 }
                                             }}/>
                </div>
            </div>
        }
        <div className="grid" style={rowStyle}>
            <div className="col-fixed" style={{width: "120px",  color: showPflichtfelder && (modusId === undefined || modusId === null || modusId === "") ? "red" : ""}}>Modus: {showPflichtfelder && "*" }</div>
            <div className="col">
                <GameModusComponent modusId={modusId}
                                    onChange={(modusId) => onModusIdChanged(modusId)}/>
            </div>
        </div>
        <div className="grid" style={rowStyle}>
            <div className="col-fixed" style={{width: "120px",  color: showPflichtfelder && (startpunkte === undefined || startpunkte === null || startpunkte === "") ? "red" : ""}}>Startpunkte: {showPflichtfelder && "*" }</div>
            <div className="col">
                <GameStartpunkteComponent startpunkte={startpunkte}
                                          onChange={(startpunkte) => onStartpunkteChanged(startpunkte)}/>
            </div>
        </div>
        {onAufnahmenBisBullenChanged !== undefined &&
            <div className="grid" style={rowStyle}>
                <DHDefaultDrawer onClose={() => setShowBullenNotice(false)} show={showBullenNotice} title={"Hinweis"} children={
                    <div style={{padding: 20}}>
                        <div style={{marginBottom: 5}}>Sobald du hier eine Anzahl von Darts speicherst, wird der Scorer das Leg durch eine
                            Bullabfrage beenden, sobald die Anzahl der Darts von den Spielern geworfen wurde.
                        </div>
                    </div>
                }/>
                <div className="col-fixed" style={{width: "120px"}}>Ausbullen:
                    <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                       onClick={() => setShowBullenNotice(!showBullenNotice)}/>
                </div>
                <div className="col">
                    <GameAusbullenComponent aufnahmenBisBullen={aufnahmenBisBullen} disabled={bullenDisabled}
                                            onChange={(value) => onAufnahmenBisBullenChanged(value)}/>
                </div>
            </div>
        }
    </>
}

TournamentX01Area.propTypes = {
    sets: PropTypes.number,
    firstToLegs: PropTypes.number,
    bestOfLegs: PropTypes.number,
    modusId: PropTypes.string,
    startpunkte: PropTypes.number,
    onSetsChanged: PropTypes.func,
    onFirstToLegsChanged: PropTypes.func.isRequired,
    onBestOfLegsChanged: PropTypes.func,
    onModusIdChanged: PropTypes.func.isRequired,
    onStartpunkteChanged: PropTypes.func.isRequired,
    aufnahmenBisBullen: PropTypes.number,
    onAufnahmenBisBullenChanged: PropTypes.func,
    bullenDisabled: PropTypes.bool,
    showSets: PropTypes.bool.isRequired,
    showBestOfLegs: PropTypes.bool.isRequired,
    showPflichtfelder: PropTypes.bool.isRequired,
};

export default TournamentX01Area
